import store from "../store/index";
//------------
// get config
//------------
export default function getConfig() {
  // console.log("-------------------");
  // console.log("newRound");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  //---------------
  // return config
  //---------------
  // store.commit("combat/setViewRound", round);
  return this_store.config;
}
